import React, { memo } from 'react'

import i18n from 'live/services/i18n'
import styled from 'styled-components'

interface CustomTableHeaderProps {
    title: string
    handleAddNewRow: () => void
}

export const CustomTableHeader = memo(
    ({ title, handleAddNewRow }: CustomTableHeaderProps): React.ReactElement => {
        return (
            <CustomTableHeaderContainer>
                <span>{i18n(title)}</span>
                <div className="table-header-divisor" />
                <button className="add-row-btn" onClick={handleAddNewRow}>
                    <i className="far fa-plus" />
                    {i18n('New')}
                </button>
            </CustomTableHeaderContainer>
        )
    }
)

CustomTableHeader.displayName = 'CustomTableHeader'

const CustomTableHeaderContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    font-size: 14px;
    font-weight: 700;
    text-transform: capitalize;

    .table-header-divisor {
        width: 1px;
        height: 20px;
        border-radius: 1px;

        background-color: var(--gray-0);
    }

    .add-row-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        line-height: 18px;

        border: none;
        border-radius: 3px;

        color: var(--gray-800);
        background-color: var(--gray-0);

        &:hover {
            opacity: 0.8;
        }
    }
`
